module.exports = __webpack_public_path__ + "img/user.3e62c017.png";